import { render, staticRenderFns } from "./TheSettingsList.vue?vue&type=template&id=1e62b454&scoped=true&"
import script from "./TheSettingsList.vue?vue&type=script&lang=ts&"
export * from "./TheSettingsList.vue?vue&type=script&lang=ts&"
import style0 from "./TheSettingsList.vue?vue&type=style&index=0&id=1e62b454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62b454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VList,VListItem,VTooltip})
